module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": "700"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('closed')
      }
    },
    model: {
      value: (_vm.viewerValue),
      callback: function($$v) {
        _vm.viewerValue = $$v
      },
      expression: "viewerValue"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-icon', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("close")])], 1), _vm._v(" "), (_vm.media.publicID && _vm.media.isvideo) ? _c('v-card-text', {
    staticClass: "text-center"
  }, [_c('custom-media-v2', {
    attrs: {
      "media": _vm.campaignHelper.customPostMediaConfig(_vm.media, {
        videoDownload: true,
        overlay: _vm.isCutOff
      })
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.media.publicID && !_vm.media.isvideo) ? _c('v-card-text', {
    staticClass: "text-center"
  }, [_c('custom-media-v2', {
    attrs: {
      "media": _vm.campaignHelper.customPostMediaConfig(_vm.media, {
        overlay: _vm.isCutOff
      })
    }
  })], 1) : _c('v-card-text', {
    staticClass: "text-center"
  }, [(!_vm.videoPlayer) ? _c('v-img', {
    attrs: {
      "src": _vm.media
    }
  }) : _vm._e(), _vm._v(" "), (_vm.videoPlayer) ? _c('video', {
    attrs: {
      "width": "300",
      "controls": ""
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.media,
      "type": "video/mp4"
    }
  }), _vm._v("\n        Your browser does not support HTML5 video.\n      ")]) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.media.url || _vm.media,
      "download": "",
      "target": "_blank"
    }
  }, [_c('v-btn', [_c('v-icon', {
    attrs: {
      "float-left": ""
    }
  }, [_vm._v("save_alt")]), _vm._v("Download")], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8cb73a1a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Post/PostMediaViewerModal.vue
// module id = 2233
// module chunks = 0